const Footer = () => {
  return (
    <footer>
      <p>Created by <a href="https://daeheumna.com/">Denny</a>, <a href="https://seldaerkilic.com/">Selda</a>, <a href="https://pedramcodes.com/">Pedram</a> & <a href="https://kenzieburke.ca">Kenzie</a> @ <a href="https://junocollege.com/">Juno College.</a></p>
    </footer>
  );
};

export default Footer;
